var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgTopaz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2725 68.3146L60.7458 38.2565C62.1947 36.3196 62.1947 33.6657 60.7458 31.7289L38.2725 1.68557C36.5944 -0.55437 33.2381 -0.55437 31.56 1.68557L9.0867 31.7363C7.63777 33.6731 7.63777 36.327 9.0867 38.2639L31.56 68.322C33.2381 70.5619 36.5944 70.5619 38.2725 68.3146Z",
    fill: "#FFA829"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2725 68.3146L60.7458 38.2565C62.1947 36.3196 62.1947 33.6657 60.7458 31.7289L38.2725 1.68557C36.5944 -0.55437 33.2381 -0.55437 31.56 1.68557L9.0867 31.7363C7.63777 33.6731 7.63777 36.327 9.0867 38.2639L31.56 68.322C33.2381 70.5619 36.5944 70.5619 38.2725 68.3146Z",
    fill: "#FFA829"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0529 34.9963H10.7796C9.11627 34.9963 8.08131 33.1038 9.06452 31.7658C9.07192 31.7584 9.07931 31.7436 9.0867 31.7362L31.56 1.6855C33.2381 -0.561833 36.5944 -0.561833 38.2725 1.6855L60.7458 31.7362C60.7532 31.7436 60.7606 31.7584 60.768 31.7658C61.7512 33.1038 60.7088 34.9963 59.0529 34.9963Z",
    fill: "#F6DA43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9592 34.9963L33.5192 69.0168C33.9997 70.3179 35.833 70.3179 36.3135 69.0168L48.8735 34.9963H20.9592Z",
    fill: "#F6DA43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9592 34.9963H20.9666H17.3886H14.609C13.9215 34.9963 13.5297 35.7799 13.9363 36.3344L25.3208 51.5556C25.8974 52.3245 27.1098 51.6739 26.7771 50.7646L20.9592 34.9963Z",
    fill: "#FFF9B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8735 34.9964H48.8661H52.4441H55.2163C55.9038 34.9964 56.2956 34.2127 55.889 33.6583L44.5045 18.4371C43.9279 17.6682 42.7155 18.3188 43.0481 19.2281L48.8735 34.9964Z",
    fill: "#ED872B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5192 0.975887L20.9592 34.9964H48.8735L36.3135 0.975887C35.833 -0.317809 33.9997 -0.317809 33.5192 0.975887Z",
    fill: "#FFF9B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopaz);
export default __webpack_public_path__ + "static/media/topaz.a6d3732a.svg";
export { ForwardRef as ReactComponent };